/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetOnboardingFlowStateQuery,
  IGetOnboardingFlowStateQueryVariables,
  GetOnboardingFlowStateDocument,
} from './types';
import { IUser } from '@r-client/data/graphql-types';
export type { IUser };

export type IGetOnboardingFlowStateQueryOpts =
  IQueryModelOpts<IGetOnboardingFlowStateQueryVariables>;

export class GetOnboardingFlowStateQuery extends BaseQueryModel<
  IGetOnboardingFlowStateQuery,
  IGetOnboardingFlowStateQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetOnboardingFlowStateQueryOpts) {
    super(opts);
  }

  get query() {
    return GetOnboardingFlowStateDocument;
  }
}
export function useGetOnboardingFlowStateQuery(
  opts?: Omit<IGetOnboardingFlowStateQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetOnboardingFlowStateQuery({ ...opts, client }),
    opts?.variables
  );
}
